<div fxLayout="column">
  <app-page-header [section]="'Transaction Schedule'"
                   [title]="'Keep an eye on transactions'"
                   [description]="'View a detailed list of every tenant transaction — item by item — with full visibility into each sale, product, and applied fee.'"></app-page-header>

  <div class="page-content page-padding full-screen-height-page-default" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" fxFlexOffset="20px">
      <span class="subtitle-default">Transaction Schedule</span>
      <span class="fx-spacer"></span>
      <app-custom-date-filter [customDateRangePresets]="dateFilters"
                              (dateRange)="getDateRange($event)">
      </app-custom-date-filter>
      <span class="body-3-default">Loaded {{ transactionScheduleData.length }} items</span>
      <button mat-icon-button (click)="loadMoreData()"
              matTooltip="Load more"
              [disabled]="!canLoadMoreData() || !!(loader.loading$ | async)">
        <mat-icon class="material-icons-outlines">update</mat-icon>
      </button>
    </div>

    <div class="mat-elevation-z3 radius-10" fxLayout="column" fxFlexOffset="15px">
      <app-crud-table
        [loading$]="loader.loading$"
        [modelType]="CrudTransactionsSummary"
        [subTitle]="'Daily Transaction Summary'"
        [tableData]="transactionScheduleData"
        [title]="'All transactions'"
      >
      </app-crud-table>
    </div>

    <div class="info-card-dark" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="30px">
      <span class="heading-bold">Notes</span>
      <span class="body-1-regular-2">Point of Sale Status: The sale status as provided by the POS software</span>
      <span class="body-1-regular-2">Sale Status: The status of the sale as per the platform processing. The platform only processes sales in the "CLOSED" status</span>
    </div>
  </div>
</div>
